import { render } from "./DownwardExpandContent.vue?vue&type=template&id=2e95c48c&scoped=true"
import script from "./DownwardExpandContent.vue?vue&type=script&lang=js"
export * from "./DownwardExpandContent.vue?vue&type=script&lang=js"

import "./DownwardExpandContent.vue?vue&type=style&index=0&id=2e95c48c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e95c48c"]])

export default __exports__